import { Delete } from "@wix/wix-ui-icons-common";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { PLUGIN_TOOLBAR_DELETE_BUTTON } from "../data-hooks.js";
import { getNodeInSelection } from "../resolvers/get-node-in-selection.js";
import { ToolbarButton as ToolbarButtonComponent } from "../toolbar-button/toolbar-button.js";
import { PLUGIN_TOOLBAR_BUTTON_ID } from "./plugin-toolbar-buttons-ids.js";
const createDeleteButton = ({
  attributes,
  command,
  tooltip
} = {}) => {
  return {
    id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE,
    type: "toggle",
    icon: Delete,
    attributes: {
      selectedNode: getNodeInSelection,
      ...attributes
    },
    dataHook: PLUGIN_TOOLBAR_DELETE_BUTTON,
    tooltip: tooltip ? tooltip : "DeleteButton_Tooltip",
    renderer: (toolbarItem) => {
      return /* @__PURE__ */ React.createElement(DeleteButton, { toolbarItem });
    },
    command: command || (({ tiptapEditor, attributes: attributes2 }) => {
      tiptapEditor.chain().focus().deleteNode(attributes2.selectedNode.attrs.id).run();
    })
  };
};
const DeleteButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  const onClick = toolbarItem.commands.click;
  return /* @__PURE__ */ React.createElement(
    ToolbarButtonComponent,
    {
      prefix: Delete,
      onClick: () => onClick ? onClick() : toolbarItem.commands.delete(),
      dataHook,
      tooltip: t("DeleteButton_Tooltip"),
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
export {
  createDeleteButton
};
//# sourceMappingURL=create-delete-button.js.map
